import pluck from 'ramda/src/pluck'
import compose from 'ramda/src/compose'
import tokensSelector from 'root/src/client/logic/api/selectors/tokensSelector'

export default compose(
	pluck('platform'),
	tokensSelector,
)
